/**
 * @fileoverview gRPC-Web generated client stub for scout.candidate.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v0.0.0
// source: scout/candidate/v1/candidate.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.scout = {};
proto.scout.candidate = {};
proto.scout.candidate.v1 = require('./candidate_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.scout.candidate.v1.CandidateServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.scout.candidate.v1.CandidateServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.SearchRequest,
 *   !proto.scout.candidate.v1.SearchResponse>}
 */
const methodDescriptor_CandidateService_Search = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/Search',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.SearchRequest,
  proto.scout.candidate.v1.SearchResponse,
  /**
   * @param {!proto.scout.candidate.v1.SearchRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.SearchResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.SearchRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.SearchResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.SearchResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.search =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/Search',
      request,
      metadata || {},
      methodDescriptor_CandidateService_Search,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.SearchRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.SearchResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.search =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/Search',
      request,
      metadata || {},
      methodDescriptor_CandidateService_Search);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.CountRequest,
 *   !proto.scout.candidate.v1.CountResponse>}
 */
const methodDescriptor_CandidateService_Count = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/Count',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.CountRequest,
  proto.scout.candidate.v1.CountResponse,
  /**
   * @param {!proto.scout.candidate.v1.CountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.CountResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.CountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.CountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.CountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.count =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/Count',
      request,
      metadata || {},
      methodDescriptor_CandidateService_Count,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.CountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.CountResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.count =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/Count',
      request,
      metadata || {},
      methodDescriptor_CandidateService_Count);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.VoteUpRequest,
 *   !proto.scout.candidate.v1.VoteUpResponse>}
 */
const methodDescriptor_CandidateService_VoteUp = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/VoteUp',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.VoteUpRequest,
  proto.scout.candidate.v1.VoteUpResponse,
  /**
   * @param {!proto.scout.candidate.v1.VoteUpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.VoteUpResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.VoteUpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.VoteUpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.VoteUpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.voteUp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/VoteUp',
      request,
      metadata || {},
      methodDescriptor_CandidateService_VoteUp,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.VoteUpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.VoteUpResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.voteUp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/VoteUp',
      request,
      metadata || {},
      methodDescriptor_CandidateService_VoteUp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.BulkVoteUpRequest,
 *   !proto.scout.candidate.v1.BulkVoteUpResponse>}
 */
const methodDescriptor_CandidateService_BulkVoteUp = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/BulkVoteUp',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.BulkVoteUpRequest,
  proto.scout.candidate.v1.BulkVoteUpResponse,
  /**
   * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.BulkVoteUpResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.BulkVoteUpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.BulkVoteUpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.bulkVoteUp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/BulkVoteUp',
      request,
      metadata || {},
      methodDescriptor_CandidateService_BulkVoteUp,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.BulkVoteUpResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.bulkVoteUp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/BulkVoteUp',
      request,
      metadata || {},
      methodDescriptor_CandidateService_BulkVoteUp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.VoteDownRequest,
 *   !proto.scout.candidate.v1.VoteDownResponse>}
 */
const methodDescriptor_CandidateService_VoteDown = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/VoteDown',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.VoteDownRequest,
  proto.scout.candidate.v1.VoteDownResponse,
  /**
   * @param {!proto.scout.candidate.v1.VoteDownRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.VoteDownResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.VoteDownRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.VoteDownResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.VoteDownResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.voteDown =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/VoteDown',
      request,
      metadata || {},
      methodDescriptor_CandidateService_VoteDown,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.VoteDownRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.VoteDownResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.voteDown =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/VoteDown',
      request,
      metadata || {},
      methodDescriptor_CandidateService_VoteDown);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.GetScoutCandidateDetailRequest,
 *   !proto.scout.candidate.v1.GetScoutCandidateDetailResponse>}
 */
const methodDescriptor_CandidateService_GetScoutCandidateDetail = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/GetScoutCandidateDetail',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.GetScoutCandidateDetailRequest,
  proto.scout.candidate.v1.GetScoutCandidateDetailResponse,
  /**
   * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.GetScoutCandidateDetailResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.GetScoutCandidateDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.GetScoutCandidateDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.getScoutCandidateDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetScoutCandidateDetail',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetScoutCandidateDetail,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.GetScoutCandidateDetailResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.getScoutCandidateDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetScoutCandidateDetail',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetScoutCandidateDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.CreateSearchOptionRequest,
 *   !proto.scout.candidate.v1.CreateSearchOptionResponse>}
 */
const methodDescriptor_CandidateService_CreateSearchOption = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/CreateSearchOption',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.CreateSearchOptionRequest,
  proto.scout.candidate.v1.CreateSearchOptionResponse,
  /**
   * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.CreateSearchOptionResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.CreateSearchOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.CreateSearchOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.createSearchOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/CreateSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_CreateSearchOption,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.CreateSearchOptionResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.createSearchOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/CreateSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_CreateSearchOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest,
 *   !proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse>}
 */
const methodDescriptor_CandidateService_GetAllSearchOptionsOrderByUpdatedAt = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/GetAllSearchOptionsOrderByUpdatedAt',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest,
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse,
  /**
   * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.getAllSearchOptionsOrderByUpdatedAt =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetAllSearchOptionsOrderByUpdatedAt',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetAllSearchOptionsOrderByUpdatedAt,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.getAllSearchOptionsOrderByUpdatedAt =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetAllSearchOptionsOrderByUpdatedAt',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetAllSearchOptionsOrderByUpdatedAt);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.GetSearchOptionRequest,
 *   !proto.scout.candidate.v1.GetSearchOptionResponse>}
 */
const methodDescriptor_CandidateService_GetSearchOption = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/GetSearchOption',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.GetSearchOptionRequest,
  proto.scout.candidate.v1.GetSearchOptionResponse,
  /**
   * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.GetSearchOptionResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.GetSearchOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.GetSearchOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.getSearchOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetSearchOption,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.GetSearchOptionResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.getSearchOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/GetSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_GetSearchOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.UpdateSearchOptionRequest,
 *   !proto.scout.candidate.v1.UpdateSearchOptionResponse>}
 */
const methodDescriptor_CandidateService_UpdateSearchOption = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/UpdateSearchOption',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.UpdateSearchOptionRequest,
  proto.scout.candidate.v1.UpdateSearchOptionResponse,
  /**
   * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.UpdateSearchOptionResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.UpdateSearchOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.UpdateSearchOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.updateSearchOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/UpdateSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_UpdateSearchOption,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.UpdateSearchOptionResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.updateSearchOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/UpdateSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_UpdateSearchOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.DeleteSearchOptionRequest,
 *   !proto.scout.candidate.v1.DeleteSearchOptionResponse>}
 */
const methodDescriptor_CandidateService_DeleteSearchOption = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/DeleteSearchOption',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.DeleteSearchOptionRequest,
  proto.scout.candidate.v1.DeleteSearchOptionResponse,
  /**
   * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.DeleteSearchOptionResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.DeleteSearchOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.DeleteSearchOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.deleteSearchOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/DeleteSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_DeleteSearchOption,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.DeleteSearchOptionResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.deleteSearchOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/DeleteSearchOption',
      request,
      metadata || {},
      methodDescriptor_CandidateService_DeleteSearchOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.SearchForAgentRequest,
 *   !proto.scout.candidate.v1.SearchForAgentResponse>}
 */
const methodDescriptor_CandidateService_SearchForAgent = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/SearchForAgent',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.SearchForAgentRequest,
  proto.scout.candidate.v1.SearchForAgentResponse,
  /**
   * @param {!proto.scout.candidate.v1.SearchForAgentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.SearchForAgentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.SearchForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.SearchForAgentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.SearchForAgentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.searchForAgent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/SearchForAgent',
      request,
      metadata || {},
      methodDescriptor_CandidateService_SearchForAgent,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.SearchForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.SearchForAgentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.searchForAgent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/SearchForAgent',
      request,
      metadata || {},
      methodDescriptor_CandidateService_SearchForAgent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.scout.candidate.v1.CountForAgentRequest,
 *   !proto.scout.candidate.v1.CountForAgentResponse>}
 */
const methodDescriptor_CandidateService_CountForAgent = new grpc.web.MethodDescriptor(
  '/scout.candidate.v1.CandidateService/CountForAgent',
  grpc.web.MethodType.UNARY,
  proto.scout.candidate.v1.CountForAgentRequest,
  proto.scout.candidate.v1.CountForAgentResponse,
  /**
   * @param {!proto.scout.candidate.v1.CountForAgentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.scout.candidate.v1.CountForAgentResponse.deserializeBinary
);


/**
 * @param {!proto.scout.candidate.v1.CountForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.scout.candidate.v1.CountForAgentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.scout.candidate.v1.CountForAgentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.scout.candidate.v1.CandidateServiceClient.prototype.countForAgent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/CountForAgent',
      request,
      metadata || {},
      methodDescriptor_CandidateService_CountForAgent,
      callback);
};


/**
 * @param {!proto.scout.candidate.v1.CountForAgentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.scout.candidate.v1.CountForAgentResponse>}
 *     Promise that resolves to the response
 */
proto.scout.candidate.v1.CandidateServicePromiseClient.prototype.countForAgent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/scout.candidate.v1.CandidateService/CountForAgent',
      request,
      metadata || {},
      methodDescriptor_CandidateService_CountForAgent);
};


module.exports = proto.scout.candidate.v1;

